import styled from "styled-components";
import Grid from "../Layout/Grid";
import Card from "./Card";

const CardList = styled(Grid)`
  margin-right: -15px;
  flex-wrap: wrap;
  align-items: stretch;

  ${Card} {
    margin-bottom: 15px;
    margin-right: 15px;

    &:hover {
      cursor: pointer;
      border-color: #aeaeb8;
    }
  }

  .property-Description {
    display: none;
  }
`;

export default CardList;



// WEBPACK FOOTER //
// ./src/UI/Card/CardList.js